import {Divider} from '@/components/ui/divider/Divider'
import {useTranslation} from '@/translations/i18n'
import {MedicalReportFieldsSchema, REPORT_TEXTAREA_LIMIT} from '../../formSchemas'
import {Controller, useFormContext} from 'react-hook-form'
import {MedicalReportTextArea} from '../medical-report-text-area/MedicalReportTextArea'
import {FormSection} from '@/components/commons/form-section/FormSection'
import {z} from 'zod'
import {UploadDocumentSectionFields} from '../upload-document-section-fields/UploadDocumentSectionFields'

const NotesSchema = MedicalReportFieldsSchema.pick({
    notes: true
})
export type NotesSchema = z.infer<typeof NotesSchema>

export const DocumentSections = () => {
    return (
        <>
            <UploadDocumentSection />
            <Divider direction="horizontal" />
            <NotesSections />
        </>
    )
}

const UploadDocumentSection = () => {
    const {t} = useTranslation()
    return (
        <FormSection title={t('commons:document')}>
            <UploadDocumentSectionFields />
        </FormSection>
    )
}

const NotesSections = () => {
    const {t} = useTranslation()
    const form = useFormContext<NotesSchema>()
    return (
        <>
            <FormSection title={t('commons:notes')}>
                <Controller
                    control={form.control}
                    name="notes"
                    render={({field, fieldState}) => (
                        <MedicalReportTextArea
                            rows={4}
                            maxLength={REPORT_TEXTAREA_LIMIT}
                            title={t('commons:notes')}
                            placeholder={t('commons:description_dot')}
                            errorMessage={fieldState.error?.message}
                            currentField="notes"
                            onChange={field.onChange}
                            value={field.value}
                        />
                    )}
                />
            </FormSection>
        </>
    )
}
